export default __webpack_public_path__ + "static/media/image1.e0e97353.jpg";